module.exports = __webpack_public_path__ + "img/Carrousels STARTO – après rdv_slide_2.df93ca85.png";